export function ComingSoon({ title }: { title: string }) {
  return (
    <>
      <div className="page-header">
        <h1>{title}</h1>
      </div>
      <div className="card">
        <p className="muted">This module hasn't been built yet.</p>
      </div>
    </>
  );
}
